"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveValidate2FARequiredEndpoints = exports.getApiInfo = exports.callFMSAPI = exports.callAPI = exports.RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS = exports.GET_API_INFO = void 0;
var _apex = _interopRequireDefault(require("../../apex"));
var _fms = require("../../services/fms/fms");
var _modalActions = require("./modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GET_API_INFO = exports.GET_API_INFO = 'GET_API_INFO';
var RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS = exports.RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS = 'RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS';
var receiveValidate2FARequiredEndpoints = exports.receiveValidate2FARequiredEndpoints = function receiveValidate2FARequiredEndpoints(payload) {
  return {
    type: RECEIVE_VALIDATE_2FA_REQUIRED_ENDPOINTS,
    payload: payload
  };
};
var getApiInfo = exports.getApiInfo = function getApiInfo() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var _getState, OMSId, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _getState = getState(), OMSId = _getState.user.userInfo.OMSId;
            _context.n = 1;
            return _apex["default"].connection.RPCPromise('GetValidate2FARequiredEndpoints', {
              OMSId: OMSId
            });
          case 1:
            data = _context.v;
            if (data) dispatch(receiveValidate2FARequiredEndpoints(JSON.parse(data.o)));
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var callAPI = exports.callAPI = function callAPI(endpoint, apiPayload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var state, validate2FARequiredEndpoints, apiCall, res;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            state = getState();
            validate2FARequiredEndpoints = state.api.validate2FARequiredEndpoints;
            if (!validate2FARequiredEndpoints[endpoint.toLowerCase()]) {
              _context3.n = 1;
              break;
            }
            apiCall = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _apex["default"].connection.RPCPromise(endpoint, data);
                    case 1:
                      return _context2.a(2, _context2.v);
                  }
                }, _callee2);
              }));
              return function apiCall(_x5) {
                return _ref3.apply(this, arguments);
              };
            }();
            return _context3.a(2, new Promise(function (resolve, reject) {
              dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.REQUIRE_2FA, {
                apiPayload: JSON.stringify(apiPayload),
                apiCall: apiCall,
                resolve: resolve,
                reject: reject
              }));
            }));
          case 1:
            _context3.n = 2;
            return _apex["default"].connection.RPCPromise(endpoint, apiPayload);
          case 2:
            res = _context3.v;
            if (!(res.o === '')) {
              _context3.n = 3;
              break;
            }
            return _context3.a(2, '');
          case 3:
            return _context3.a(2, JSON.parse(res.o));
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var callFMSAPI = exports.callFMSAPI = function callFMSAPI(endpoint, apiPayload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_dispatch, getState) {
      var token, gw, res;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            token = getState().auth.token;
            gw = (0, _fms.getFMS)(token); // Normal API call.
            _context4.n = 1;
            return gw.connection.RPCPromise(endpoint, apiPayload);
          case 1:
            res = _context4.v;
            return _context4.a(2, JSON.parse(res.o));
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};